<template>
  <div>
    <a-descriptions title="Info Shift / Thông tin ca làm việc" :column="1">
      <a-descriptions-item label="Shift / Ca làm việc">
        {{ workShift.title }}
      </a-descriptions-item>
      <a-descriptions-item label="Code / Mã">
        {{ workShift.code }}
      </a-descriptions-item>
      <a-descriptions-item label="Weekday / Ngày làm việc">
        <span v-for="(day, index) in dayInWeeks" :key="index">
          <span>
            {{ convertDayInWeekToNameDate(day) }}
            <span v-if="index < dayInWeeks.length - 1">,</span>
          </span>
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Working Time / Giờ làm việc">
        {{ workShift.startTime | formatTime }} -
        {{ workShift.endTime | formatTime }}
      </a-descriptions-item>
      <a-descriptions-item
        label="Break Time / Nghỉ giữa giờ"
        v-if="workShift.startBreakTime && workShift.endBreakTime"
      >
        {{ workShift.startBreakTime | formatTime }} -
        {{ workShift.endBreakTime | formatTime }}
      </a-descriptions-item>
      <a-descriptions-item label="Working hours / Tổng số giờ làm việc">
        {{ workShift.duration }}
      </a-descriptions-item>
    </a-descriptions>
    <CollapseCard>
      <div slot="content">
        <a-alert
          v-if="workShift && workShift.id"
          type="info"
          style="white-space: pre-line; display: block;"
        >
          <div
            slot="message"
            v-if="workShift.description"
            v-html="workShift.description"
          ></div>
          <div slot="message" v-else>
            Empty
          </div>
        </a-alert>
      </div>
    </CollapseCard>
  </div>
</template>
<script>
import CollapseCard from "@/components/common/collapseCard";
import { dayOfWeeks } from "./constant/default";
export default {
  components: { CollapseCard },
  props: {
    workShift: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dayInWeeks: [],
    };
  },
  created() {
    if (this.workShift?.dayInWeeks) {
      this.dayInWeeks = JSON.parse(this.workShift.dayInWeeks);
    }
  },
  methods: {
    convertDayInWeekToNameDate(dayInWeek) {
      if (dayOfWeeks?.length > 0) {
        const index = dayOfWeeks.findIndex((e) => e.key === dayInWeek);
        if (index >= 0) {
          return dayOfWeeks[index].Title;
        }
      }

      return "Không có ngày";
    },
  },
};
</script>
<style lang="css" scoped></style>
